import { ArrowLeft } from 'blaze-ui/icons'
import { useHistory } from 'react-router-dom'
import { useCallback } from 'react'
import { Button } from 'blaze-components/WriterTopBar/Button'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

export const BackButton = ({ iconOnly = false }: { iconOnly?: boolean }) => {
  const history = useHistory()

  const goBack = useCallback(() => {
    history.goBack()
  }, [history])

  if (iconOnly) {
    return <IconButton icon={ArrowLeft} aria-label="Back" onPress={goBack} variant="secondary" />
  }

  return (
    <Button icon={ArrowLeft} aria-label="Back" onPress={goBack}>
      Back
    </Button>
  )
}
